It was decided with Ronni to make a separate paage for user tryinng to sign up aggain
<template>
	<UserRegistrationLayout class="resent-verification-email-successfully">
		<SIcon name="key"></SIcon>
		<div class="slot-title">
			We've resent a confirmation email to <span class="email-text">{{ userEmail }}</span>
		</div>
		<div class="right-side-description">Please check your inbox</div>
		<div class="bottom-section">
			After confirming go to
			<a @click="navigateTo({ name: 'Login' })" class="primary-link-style">Log in</a>
		</div>
	</UserRegistrationLayout>
</template>

<script>
import { mapActions } from 'vuex';

import UserRegistrationLayout from './UserRegistrationLayout';
import UserRegistrationMixin from './helpers/UserRegistrationMixin';

export default {
	name: 'ResentVerificationEmailSuccessfully',
	components: {
		UserRegistrationLayout,
	},
	props: {
		userEmail: { type: String },
	},
	mixins: [UserRegistrationMixin],
	methods: {
		...mapActions(['resendConfirmationEmail']),
	},
};
</script>

<style scoped lang="scss">
.resent-verification-email-successfully {
	.right-side-section {
		.slot-title {
			margin: 30px 0 40px;
		}
	}

	.email-text {
		color: var(--primary-color);
	}
}
</style>
